import React from 'react';
import { Box, Typography, Link } from '@mui/material';
import ReactMarkdown from 'markdown-to-jsx';

const Markdown = ({ children }) => {
  function MarkdownListItem(props) {
    return (
      <Box component="li" sx={{ mt: 1, typography: 'body1' }} {...props} />
    );
  }

  const markdownOptions = {
    overrides: {
      h1: {
        component: Typography,
        props: {
          gutterBottom: true,
          variant: 'h4',
          component: 'h1',
        },
      },
      h2: {
        component: Typography,
        props: { gutterBottom: true, variant: 'h6', component: 'h2' },
      },
      h3: {
        component: Typography,
        props: { gutterBottom: true, variant: 'subtitle1' },
      },
      h4: {
        component: Typography,
        props: {
          gutterBottom: true,
          variant: 'caption',
          paragraph: true,
        },
      },
      p: {
        component: Typography,
        props: { paragraph: true, gutterBottom: true },
      },
      a: { component: Link },
      li: {
        component: MarkdownListItem,
      },
    },
    forceBlock: true,
  };

  return <ReactMarkdown options={markdownOptions}>{children}</ReactMarkdown>;
};

export default Markdown;
